import { Controller } from "@hotwired/stimulus"

// Tabs for the "Find us here" section on a multi-branch storefront.
//
// Every branch panel is rendered and all but one hidden, so switching costs no
// request and the addresses are all in the page for a crawler to read.
export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const id = event.currentTarget.dataset.branchId

    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.branchId === id
      tab.setAttribute("aria-selected", on)
      tab.classList.toggle("bg-primary-1", on)
      tab.classList.toggle("text-ink", on)
      tab.classList.toggle("bg-gray-100", !on)
      tab.classList.toggle("text-slate-700", !on)
      tab.classList.toggle("hover:bg-gray-200", !on)
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.branchId !== id)
    })
  }
}
